import React, { useContext, useState } from 'react';
import SharedPassageInjector from 'chameleon/packages/blue-book-player/library/SharedPassageInjector';
import {
  createSharedFeaturesTree,
  computeSharedPassageInfos,
} from 'chameleon/packages/blue-book-player/utility/sharedPassage';
import useListenToRenderedQuestions from 'chameleon/packages/blue-book-player/hooks/useListenToRenderedQuestions';
import { BluebookContext } from '../state/BluebookContext';

const SharedPassageInfoInit = (props) => {
  const [sharedPassageInfos, setSharedPassageInfos] = useState([]);
  const { learnosityApp } = props;
  const { state: playerState } = useContext(BluebookContext);

  useListenToRenderedQuestions(playerState, learnosityApp, () => {
    if (!learnosityApp) {
      return;
    }
    const lrnItems = learnosityApp?.getItems();
    const sharedFeaturesTree = createSharedFeaturesTree(lrnItems);
    const computedSharedPassageInfos = computeSharedPassageInfos(
      Object.keys(lrnItems),
      sharedFeaturesTree,
    );
    setSharedPassageInfos(computedSharedPassageInfos);
  });

  return sharedPassageInfos.map((sharedPassageInfo) => (
    <SharedPassageInjector
      key={sharedPassageInfo.questionIndexStart}
      questionIndexStart={sharedPassageInfo.questionIndexStart}
      questionIndexEnd={sharedPassageInfo.questionIndexEnd}
      questionsReferences={sharedPassageInfo.questionsReferences}
    />
  ));
};

export default SharedPassageInfoInit;
